const LogoIcon = ({ width = 32, height = 26, className = "" }) => {
  // Calculate the scaling factor based on the original viewBox
  const viewBoxWidth = 32;
  const viewBoxHeight = 26;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="Volca logo">
        <path
          id="Volca-logo"
          d="M23.4814 8.9743L17.2014 6.17694L31.8585 0L31.8787 5.83898L23.4814 8.9743ZM31.98 19.2785L23.5614 16.194L17.3008 19.0344L32 25.1175L31.98 19.2785ZM27.3154 12.8729L27.3134 12.2756L19.9367 8.98976L13.6567 6.1924L0 0.109238L0.0201154 5.94822L7.39616 9.03278L9.25182 9.80881L3.64221 12.3539L3.64425 12.9513L9.27817 15.4608L7.42103 16.2525L0.0663996 19.3877L0.0865153 25.2267L13.7011 19.0497L19.9616 16.2094L27.3154 12.8729Z"
          fill="url(#paint0_linear_1_379)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1_379"
          x1="30.2383"
          y1="26.8793"
          x2="1.73415"
          y2="-1.62492"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E51000" />
          <stop offset="1" stopColor="#FF7C38" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default LogoIcon;
